import React from "react";
import { useHeaderHeight } from "../../../hooks/useHeaderHeight";
import { useScrollHeight } from "../../../hooks/useScrollHeight";
import { isSpecificSite } from "../../../utils/isSpecificSite";
import HeaderMinimal from "./Minimal/HeaderMinimal";

export const MinimalHeader: React.FC = () => {
	isSpecificSite("ie", "MinimalHeader");
	const headerHeight = useHeaderHeight();
	const scrollHeight = useScrollHeight();

	return (
		<HeaderMinimal scrollHeight={scrollHeight} headerHeight={headerHeight} />
	);
};

export default MinimalHeader;
